import {
  SET_STOCK_HISTORY,
  SET_STOCK_HISTORY_ERROR,
  SET_STOCK_HISTORY_LOADING,
} from "../../actions/stockHistoryAction";

const initialState = {
  datas: null,
  loading: false,
  error: null,
};

const stockHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STOCK_HISTORY:
      return {
        ...state,
        datas: action.data,
        error: null,
      };
    case SET_STOCK_HISTORY_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    case SET_STOCK_HISTORY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default stockHistoryReducer;
